import { HttpService } from "./http.service";
import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";

const basePath = "/Group";
const request = HttpService.handleRequest();

export const GroupService = {
  getAll,
  getList,
  insert,
  update,
  del,
  getById,
  remove,
  insertOrUpdate
};

async function getAll() {
  return request.get(basePath);
}

async function insertOrUpdate(data) {
  return request.post(`${basePath}/create`, data);
}

async function insert(data) {
  return request.post(basePath, data);
}

async function update(data) {
  return request.put(basePath, data);
}

async function del(data) {
  return request.delete(basePath, { data });
}

async function remove(data) {
  return request.post(`${basePath}/remove`, data);
}

async function getById(id) {
  return request.get(`${basePath}/${id}`);
}

async function getList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

export default GroupService;